export const TASK_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed',
};

export const TASK_PRIORITY = {
  LOW: 'low',
  NORMAL: 'normal',
  HIGH: 'high',
  URGENT: 'urgent',
};

export const TASK_VIEWS = [
  { id: 'all', label: 'All' },
  { id: 'due_today', label: 'Due today' },
  { id: 'overdue', label: 'Overdue' },
  { id: 'upcoming', label: 'Upcoming' },
];

export const LOCKED_FIELDS = ['status', 'title', 'actions'];

export const DEFAULT_TABLE_FIELDS = [
  'status',
  'title',
  'description',
  'associated_contacts',
  'assignee',
  'due_at',
  'actions',
];

export const ALL_TABLE_FIELDS = [
  { key: 'status', label: 'Status', locked: true, category: 'Task Info' },
  { key: 'title', label: 'Title', locked: true, category: 'Task Info' },
  { key: 'description', label: 'Description', category: 'Task Info' },
  { key: 'due_at', label: 'Due Date', category: 'Task Info' },
  { key: 'priority', label: 'Priority', category: 'Other details' },
  { key: 'associated_contacts', label: 'Associated Contacts', category: 'Associations' },
  { key: 'associated_opportunities', label: 'Associated Opportunities', category: 'Associations' },
  { key: 'associated_companies', label: 'Associated Companies', category: 'Associations' },
  { key: 'assignee', label: 'Assignee', category: 'Other details' },
  { key: 'record_id', label: 'Record ID', category: 'Other details' },
  { key: 'created_at', label: 'Created At', category: 'Other details' },
  { key: 'updated_at', label: 'Updated At', category: 'Other details' },
  { key: 'actions', label: 'Actions', locked: true, category: 'Task Info' },
];

export const SORT_OPTIONS = [
  { field: 'due_at', direction: 'asc', label: 'Due date ascending' },
  { field: 'due_at', direction: 'desc', label: 'Due date descending' },
  { field: 'created_at', direction: 'desc', label: 'Newest created' },
  { field: 'created_at', direction: 'asc', label: 'Oldest created' },
  { field: 'updated_at', direction: 'desc', label: 'Recently updated' },
  { field: 'title', direction: 'asc', label: 'Title A-Z' },
  { field: 'title', direction: 'desc', label: 'Title Z-A' },
];

export const DUE_DATE_QUICK_OPTIONS = [
  { value: '', label: 'Any date' },
  { value: 'today', label: 'Today' },
  { value: 'tomorrow', label: 'Tomorrow' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'this_week', label: 'This week' },
  { value: 'this_month', label: 'This month' },
  { value: 'this_quarter', label: 'This quarter' },
  { value: 'this_year', label: 'This year' },
  { value: 'overdue', label: 'Overdue' },
  { value: 'on', label: 'On' },
  { value: 'between', label: 'Between' },
  { value: 'before_date', label: 'Before date' },
  { value: 'after_date', label: 'After date' },
  { value: 'in_the_next', label: 'In the next' },
  { value: 'in_the_last', label: 'In the last' },
];

export const TEXT_OPERATORS = [
  { value: 'is', label: 'Is' },
  { value: 'is_not', label: 'Is not' },
  { value: 'contains', label: 'Contains' },
  { value: 'does_not_contain', label: 'Does not contain' },
  { value: 'is_not_empty', label: 'Is not empty' },
  { value: 'is_empty', label: 'Is empty' },
];

export const STATUS_OPERATORS = [
  { value: 'is', label: 'Is' },
  { value: 'is_not', label: 'Is not' },
  { value: 'is_not_empty', label: 'Is not empty' },
  { value: 'is_empty', label: 'Is empty' },
];

export const ASSOCIATION_OPERATORS = [
  { value: 'contains_any', label: 'Contains any' },
  { value: 'does_not_contain_any', label: 'Does not contain any' },
  { value: 'is_not_empty', label: 'Is not empty' },
  { value: 'is_empty', label: 'Is empty' },
];

export const ASSIGNEE_OPERATORS = [
  { value: 'is_any', label: 'Is any' },
  { value: 'is_not_any', label: 'Is not any' },
  { value: 'is_assigned', label: 'Is assigned' },
  { value: 'is_unassigned', label: 'Is unassigned' },
];

export const DATE_OPERATORS = [
  { value: 'today', label: 'Today' },
  { value: 'tomorrow', label: 'Tomorrow' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'this_week', label: 'This week' },
  { value: 'this_month', label: 'This month' },
  { value: 'this_quarter', label: 'This quarter' },
  { value: 'this_year', label: 'This year' },
  { value: 'on', label: 'On' },
  { value: 'between', label: 'Between' },
  { value: 'more_than', label: 'More than' },
  { value: 'less_than', label: 'Less than' },
  { value: 'after_date', label: 'After date' },
  { value: 'before_date', label: 'Before date' },
  { value: 'in_the_next', label: 'In the next' },
  { value: 'in_the_last', label: 'In the last' },
  { value: 'is_not_empty', label: 'Is not empty' },
  { value: 'is_empty', label: 'Is empty' },
];

export const FILTER_FIELDS = [
  { key: 'title', label: 'Title', category: 'Task Info', type: 'text' },
  { key: 'description_text', label: 'Description', category: 'Task Info', type: 'text' },
  { key: 'status', label: 'Status', category: 'Task Info', type: 'status' },
  { key: 'due_at', label: 'Due Date', category: 'Task Info', type: 'date' },
  { key: 'priority', label: 'Priority', category: 'Task Info', type: 'status' },
  { key: 'associated_contacts', label: 'Associated Contacts', category: 'Associations', type: 'association' },
  { key: 'associated_opportunities', label: 'Associated Opportunities', category: 'Associations', type: 'association' },
  { key: 'associated_companies', label: 'Associated Companies', category: 'Associations', type: 'association' },
  { key: 'assignee_user_id', label: 'Assignee', category: 'Other details', type: 'assignee' },
  { key: 'created_at', label: 'Created At', category: 'Other details', type: 'date' },
  { key: 'updated_at', label: 'Updated At', category: 'Other details', type: 'date' },
];

export const TASK_PERMISSIONS = {
  VIEW: 'tasks.view',
  CREATE: 'tasks.create',
  EDIT: 'tasks.edit',
  DELETE: 'tasks.delete',
  ASSIGN: 'tasks.assign',
  MANAGE_ALL: 'tasks.manage_all',
  MANAGE_FIELDS: 'tasks.manage_fields',
  BULK_MANAGE: 'tasks.bulk_manage',
  EXPORT: 'tasks.export',
};

export const MAX_TITLE_LENGTH = 160;
export const MAX_DESCRIPTION_LENGTH = 2000;

export function getPlatformTasksRoute() {
  return '/platform/tasks';
}

export function getPlatformTaskBulkActionsRoute() {
  return '/platform/tasks/bulk-actions';
}

export function getAgencyTasksRoute(agencyId) {
  return `/agency/${agencyId}/tasks`;
}

export function getAgencyTaskBulkActionsRoute(agencyId) {
  return `/agency/${agencyId}/tasks/bulk-actions`;
}

export function operatorsForFieldType(type) {
  if (type === 'text') return TEXT_OPERATORS;
  if (type === 'status') return STATUS_OPERATORS;
  if (type === 'association') return ASSOCIATION_OPERATORS;
  if (type === 'assignee') return ASSIGNEE_OPERATORS;
  if (type === 'date') return DATE_OPERATORS;
  return TEXT_OPERATORS;
}
